import { types, userStore } from "@/BaseComponent";

export const utils = {
    regexForId: /^[A-Za-z0-9_]{6,12}$/,
    regexForPassword: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_\+\-=\[\]{}|;:'",.<>?/])[A-Za-z\d!@#$%^&*()_\+\-=\[\]{}|;:'",.<>?/]{8,}$/,
    regexForEmail: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
    regexForPhone: /^01[016789]-?\d{3,4}-?\d{4}$/,
    regexForBirth: /^(19[0-9]{2}|20[0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])$/,
    isValidDate: (dateStr: string) => {
        // YYYYMMDD 형식 체크
        if (!utils.regexForBirth.test(dateStr)) {
            return false;
        }

        const year = parseInt(dateStr.substring(0, 4), 10);
        const month = parseInt(dateStr.substring(4, 6), 10);
        const day = parseInt(dateStr.substring(6, 8), 10);

        // 실제 존재하는 날짜인지 체크
        const date = new Date(year, month - 1, day);
        return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
    },
    imgRender: (files: any, imgUrl: any) => {
        const file = files[0];
        let imgUrls = imgUrl;
        // FileReader 객체 : 웹 애플리케이션이 데이터를 읽고, 저장하게 해줌
        const reader = new FileReader();

        // load 이벤트 핸들러. 리소스 로딩이 완료되면 실행됨.
        reader.onload = (ee: any) => {
            imgUrls = ee.target.result;
        }; // ref previewImage 값 변경

        // 컨텐츠를 특정 file에서 읽어옴. 읽는 행위가 종료되면 loadend 이벤트 트리거함
        // & base64 인코딩된 스트링 데이터가 result 속성에 담김
        reader.readAsDataURL(file);
    },
    getImgUrl: (file: File) => {
        return URL.createObjectURL(file);
    },

    numberFormat: (number: number | string) => {
        const formatNum = number.toString();
        return formatNum.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    formatDate: (isoDateString: string): string => {
        const date = new Date(isoDateString);

        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        const hours = ("0" + date.getHours()).slice(-2);
        const minutes = ("0" + date.getMinutes()).slice(-2);

        const formattedDateString = `${year}.${month}.${day} ${hours}:${minutes}`;

        return formattedDateString;
    },
    dateFormat: (selectDate: number | string | Date, format: string | null, isShowHour: boolean) => {
        let date: Date;
        if (selectDate) {
            if (typeof selectDate === "string") {
                const year = parseInt(selectDate.substring(0, 4), 10);
                const month = parseInt(selectDate.substring(4, 6), 10) - 1;
                const day = parseInt(selectDate.substring(6, 8), 10);

                const hour = parseInt(selectDate.substring(8, 10), 10);
                const minute = parseInt(selectDate.substring(8, 10), 10);
                const second = parseInt(selectDate.substring(8, 10), 10);

                date = new Date(year, month, day, hour, minute, second);
            } else if (typeof selectDate === "number") {
                date = new Date(selectDate);
            } else {
                date = selectDate;
            }
            const formattedYear: number = date.getFullYear();
            let formattedMonth: number | string = date.getMonth() + 1;
            formattedMonth = formattedMonth < 10 ? "0" + formattedMonth : formattedMonth.toString();
            let formattedDay: number | string = date.getDate();
            formattedDay = formattedDay < 10 ? "0" + formattedDay : formattedDay.toString();

            let formattedHour: number | string = date.getHours();
            formattedHour = formattedHour < 10 ? "0" + formattedHour : formattedHour.toString();
            let formattedMinute: number | string = date.getMinutes();
            formattedMinute = formattedMinute < 10 ? "0" + formattedMinute : formattedMinute.toString();
            let formattedSecond: number | string = date.getSeconds();
            formattedSecond = formattedSecond < 10 ? "0" + formattedSecond : formattedSecond.toString();

            const divFormat = format === null ? "-" : format;

            let resultDate = `${formattedYear}${divFormat}${formattedMonth}${divFormat}${formattedDay}`;

            if (isShowHour) resultDate = resultDate + ` ${formattedHour}:${formattedMinute}:${formattedSecond}`;

            return resultDate;
        } else {
            return "";
        }
    },

    dateFormatForMobile: (selectDate: number | string | Date, format: string | null, isShowHour: boolean) => {
        let date: Date;
        if (selectDate) {
            if (typeof selectDate === "string") {
                const year = parseInt(selectDate.substring(0, 4), 10);
                const month = parseInt(selectDate.substring(4, 6), 10) - 1;
                const day = parseInt(selectDate.substring(6, 8), 10);

                const hour = parseInt(selectDate.substring(8, 10), 10);
                const minute = parseInt(selectDate.substring(8, 10), 10);
                const second = parseInt(selectDate.substring(8, 10), 10);

                date = new Date(year, month, day, hour, minute, second);
            } else if (typeof selectDate === "number") {
                date = new Date(selectDate);
            } else {
                date = selectDate;
            }
            const formattedYear: number = date.getFullYear();
            let formattedMonth: number | string = date.getMonth() + 1;
            formattedMonth = formattedMonth < 10 ? "0" + formattedMonth : formattedMonth.toString();
            let formattedDay: number | string = date.getDate();
            formattedDay = formattedDay < 10 ? "0" + formattedDay : formattedDay.toString();

            let formattedHour: number | string = date.getHours();
            formattedHour = formattedHour < 10 ? "0" + formattedHour : formattedHour.toString();
            let formattedMinute: number | string = date.getMinutes();
            formattedMinute = formattedMinute < 10 ? "0" + formattedMinute : formattedMinute.toString();
            let formattedSecond: number | string = date.getSeconds();
            formattedSecond = formattedSecond < 10 ? "0" + formattedSecond : formattedSecond.toString();

            const divFormat = format === null ? "-" : format;

            let resultDate = `${formattedYear}${divFormat}${formattedMonth}${divFormat}${formattedDay}`;

            if (isShowHour) resultDate = resultDate + ` ${formattedHour}:${formattedMinute}`;

            return resultDate;
        } else {
            return "";
        }
    },

    dateFormatYY: (selectDate: number | string | Date, format: string | null) => {
        let date: Date;
        if (selectDate) {
            if (typeof selectDate === "string") {
                const year = parseInt(selectDate.substring(0, 4), 10);
                const month = parseInt(selectDate.substring(4, 6), 10) - 1;
                const day = parseInt(selectDate.substring(6, 8), 10);

                date = new Date(year, month, day);
            } else if (typeof selectDate === "number") {
                const dateString = selectDate.toString();
                const year = parseInt(dateString.substring(0, 4), 10);
                const month = parseInt(dateString.substring(4, 6), 10) - 1;
                const day = parseInt(dateString.substring(6, 8), 10);

                date = new Date(year, month, day);
            } else {
                date = selectDate;
            }

            const formattedYear: string = date.getFullYear().toString().slice(2);
            let formattedMonth: string = (date.getMonth() + 1).toString().padStart(2, "0");
            let formattedDay: string = date.getDate().toString().padStart(2, "0");
            const divFormat = format === null ? "-" : format;

            return `${formattedYear}${divFormat}${formattedMonth}${divFormat}${formattedDay}`;
        } else {
            return "";
        }
    },

    dateFormatYYYYMM: (selectDate: number | string | Date, format: string | null) => {
        let date: Date;
        if (selectDate) {
            if (typeof selectDate === "string") {
                const year = parseInt(selectDate.substring(0, 4), 10);
                const month = parseInt(selectDate.substring(4, 6), 10) - 1;
                const day = parseInt(selectDate.substring(6, 8), 10);

                date = new Date(year, month, day);
            } else if (typeof selectDate === "number") {
                const dateString = selectDate.toString();
                const year = parseInt(dateString.substring(0, 4), 10);
                const month = parseInt(dateString.substring(4, 6), 10) - 1;
                const day = parseInt(dateString.substring(6, 8), 10);

                date = new Date(year, month, day);
            } else {
                date = selectDate;
            }

            const formattedYear: string = date.getFullYear().toString();
            let formattedMonth: string = (date.getMonth() + 1).toString().padStart(2, "0");
            const divFormat = format === null ? "-" : format;

            return `${formattedYear}${divFormat}${formattedMonth}`;
        } else {
            return "";
        }
    },

    convertPhoneNumReal: (phoneNum: string) => {
        if (!phoneNum) {
            return { phoneNum1: "", phoneNum2: "", phoneNum3: "" };
        } else {
            const strPhoneNum = phoneNum.replace(/\D/g, "");

            return strPhoneNum.slice(0, 3) + "-" + strPhoneNum.slice(3, 7) + "-" + strPhoneNum.slice(7, 11);
        }
    },

    getDDayHour: (param: Date) => {
        const now = new Date();

        const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const targetDate = new Date(param.getFullYear(), param.getMonth(), param.getDate());

        const diffDays = Math.floor((targetDate.getTime() - nowDate.getTime()) / (1000 * 60 * 60 * 24));

        if (diffDays === 0) return "D-Day";
        if (diffDays < 0) return "";

        const diffMs = param.getTime() - now.getTime();
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const hours = diffHours % 24;

        return `D-${diffDays} ${hours}h`;
    },

    checkImageSrc: (url: string) => {
        return new Promise((resolve) => {
            const img = new Image();

            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);

            img.src = url;
        });
    },

    makeBoundary: () => {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let boundary = "----WebKitFormBoundary";
        for (let i = 0; i < 16; i++) {
            boundary += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return boundary;
    },
    decodeContent: (encoded: string) => {
        try {
            if (encoded) {
                // 1. URL 디코딩
                let base64 = decodeURIComponent(encoded);

                // 2. URL-safe Base64를 일반 Base64로 변환
                base64 = base64.replace(/-/g, "+").replace(/_/g, "/");

                // 이미 정상문자인 경우 return
                if (!/^[A-Za-z0-9+/=]+$/.test(base64)) {
                    return encoded;
                }

                // 3. 길이 맞추기 (4의 배수가 아니면 = 추가)
                while (base64.length % 4) {
                    base64 += "=";
                }

                // 4. atob → binary string
                const binaryString = atob(base64);

                const reEncoded = btoa(binaryString).replace(/=+$/, "");
                const original = base64.replace(/=+$/, "");

                if (reEncoded !== original) {
                    return encoded;
                }

                // 5. binary string → Uint8Array
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }

                // 6. TextDecoder로 UTF-8 변환
                const decoder = new TextDecoder("utf-8").decode(bytes);
                // 7. 영문 깨짐 방지
                if (!decoder || /�/.test(decoder)) {
                    return encoded;
                }

                return decoder;
            } else return encoded;
        } catch (error) {
            console.error("디코딩 실패:", error);
            return "";
        }
    },
    encodeContent: (str: string) => {
        const encoder = new TextEncoder();
        const bytes = encoder.encode(str);

        // Uint8Array → binary string
        let binary = "";
        bytes.forEach((b) => (binary += String.fromCharCode(b)));

        // binary string → Base64 → URL-safe
        return encodeURIComponent(btoa(binary));
    },

    getToday: () => {
        const today = new Date();
        return today.toISOString().split("T")[0]; // yyyy-MM-dd
    },

    getAreaCoordsForRect: (coords: string, img: HTMLImageElement) => {
        // 이미지 좌표 계산용
        // 이미지 좌표는 https://www.image-map.net/ 에서 coords 부분 사용
        const [x1, y1, x2, y2] = coords.split(",").map(Number);

        const containerWidth = img.clientWidth;
        const containerHeight = img.clientHeight;

        const naturalWidth = img.naturalWidth;
        const naturalHeight = img.naturalHeight;

        const scale = Math.min(containerWidth / naturalWidth, containerHeight / naturalHeight);

        const renderedWidth = naturalWidth * scale;
        const renderedHeight = naturalHeight * scale;

        const offsetX = (containerWidth - renderedWidth) / 2;
        const offsetY = (containerHeight - renderedHeight) / 2;

        const newX1 = offsetX + x1 * scale;
        const newY1 = offsetY + y1 * scale;
        const newX2 = offsetX + x2 * scale;
        const newY2 = offsetY + y2 * scale;

        return `${newX1},${newY1},${newX2},${newY2}`;
    },
    htmlToText: (html: string) => {
        const div = document.createElement("div");
        div.innerHTML = html;

        return div.innerText;
    },
    allFocusOut: () => {
        const activeElement = document.activeElement as HTMLElement | null;
        if (activeElement) activeElement.blur();
    },
    checkIsMobile: (width: number = 768): boolean => {
        if (window.innerWidth > width) return false;
        else return true;
    },
    checkAuth: (): boolean => {
        const user = userStore();
        if (
            user.isLogin() &&
            (user.userInfo.gubun === 1 ||
                (user.userInfo.isAdmin == true && user.roles != null && user.roles.some((item: types.RoleVO) => item.key.indexOf("activity") > -1)) ||
                user.userInfo.hasAuth)
        ) {
            return true;
        } else return false;
    },
    errorImg: (event: Event) => {
        const target = event.target as HTMLImageElement;
        target.src = require("@/assets/no_img.png");
    },
};
